// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__QVljb","androidImg":"Table_androidImg__yInbd","copyImg":"Table_copyImg__hfe6y","forminput":"Table_forminput__3arIA","truncatetext":"Table_truncatetext__1yMY5"};